module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/vnRktE/tc-custom/9780547819242.jpg?1718044270768",
      "alt": "This image is the cover for the book Best American Short Stories 2014, The Best American Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Best American Short Stories 2014, The Best American Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("“The literary ‘Oscars’ features twenty outstanding examples of the best of the best in American short stories.” — "), _c('i', [_vm._v("Shelf Awareness for Readers")])])]), _c('p', [_c('i', [_vm._v("The Best American Short Stories 2014")]), _vm._v(" will be selected by national best-selling author Jennifer Egan, who won the 2011 Pulitzer Prize and the National Book Critics Circle Award for fiction for "), _c('i', [_vm._v("A Visit from the Goon Squad,")]), _vm._v(" heralded by "), _c('i', [_vm._v("Time")]), _vm._v(" magazine as “a new classic of American fiction.” Egan “possesses a satirist’s eye and a romance novelist’s heart” ("), _c('i', [_vm._v("New York Times Book Review")]), _vm._v(").")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jennifer Egan, Heidi Pitlor\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Houghton Mifflin Harcourt (www.hmhco.com)\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0